import { useQuery } from '@tanstack/react-query'

import { FieldHistoryAPI, FieldHistoryResult, MpxResponseError } from '@cibo/core'

import { LAND_REPORT_QUERY_KEY } from './consts'

export const useFieldHistory = (resourceId?: string) => {
  return useQuery<FieldHistoryResult | undefined, MpxResponseError>(
    [LAND_REPORT_QUERY_KEY.FIELD_HISTORY, resourceId],
    // @ts-ignore
    () => FieldHistoryAPI.fetch({ resourceId }),
    {
      enabled: !!resourceId,
    }
  )
}
